module.exports = __webpack_public_path__ + "img/jd.6fc56d35.png";